import { forwardRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import Paper from "@mui/material/Paper";

import Button from "features/components/Button";
import TextField from "features/components/TextField";
import SearchIcon from "features/ui/Icons/SearchIcon";

export const CustomDropdown = forwardRef(function CustomDropdown(
  props: any,
  ref
) {
  const { t } = useTranslation("filters");
  const {
    children,
    searchTerm,
    setSearchTerm,
    onSelectAll,
    onClear,
    hideSearch,
    hideActions,
    ...other
  } = props;

  return (
    <Paper ref={ref} {...other} className={classNames(other.className)}>
      <List
        subheader={
          <ListSubheader className="!p-3 !pb-0" disableSticky>
            {!hideSearch && (
              <TextField
                type="text"
                size="medium"
                fullWidth
                value={searchTerm}
                onChange={({ target: { value } }) => {
                  setSearchTerm(value);
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  },
                }}
                autoFocus
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              />
            )}
            {!hideActions && (
              <div className="flex flex-row gap-[10px] mb-2">
                <Button
                  color="secondary"
                  size="xs"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onSelectAll?.();
                  }}
                >
                  {t("common:select_all")}
                </Button>
                <Button
                  color="secondary"
                  size="xs"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClear?.();
                  }}
                >
                  {t("actions.clear")}
                </Button>
              </div>
            )}
            <hr className="border-gray-100" />
          </ListSubheader>
        }
      >
        {children}
      </List>
    </Paper>
  );
});
